import constants from '../../helpers/constants';
import tooltips from './components/tooltips';

const columnsConstants = {
  STANDART_COLUMNS: {
    overdue: true,
    overload: false,
    wbs: true,
    comments: false,
    attachments: false,
    start_date: false,
    end_date: false,
    create_date: false,
    creator: false,
    estimation: false,
    total_price: false,
    actual_cost: false,
    resource_id: true,
    assigned: true,
    // owner_id: false,
    progress: false,
    duration: false,
    time_tracking: false, //! app.config.mode.isExport,
    priority: false,
    status: true,
    predecessors: false,
    jira_key: false,
    total_float: false,
    free_float: false,
    project_name: true,
    project_path: false,
  },
  STANDART_COLUMNS_ICONS: {
    overload: 'resource',
    wbs: 'left-list',
    comments: 'comments',
    attachments: 'attach',
    start_date: 'startDate',
    end_date: 'endDate',
    create_date: 'calendar',
    created_at: 'calendar',
    creator: 'role',
    estimation: 'estimation',
    total_price: 'cost-2',
    actual_cost: 'cost-1',
    resource_id: 'user',
    assigned: 'user',
    // owner_id: false,
    progress: 'progress',
    duration: 'duration',
    time_tracking: 'timer',
    priority: 'priority',
    status: 'status-1',
    predecessors: 'predesessor',
    project_name: 'project',
    project_path: 'critical-path',
    jira_key: 'key',
    advancedOptions: {
      start_date: 'time',
      end_date: 'time',
      project_name: 'critical-path',
    },
    text: 'task',
    total_float: 'task',
    free_float: 'task',
  },
  STANDART_COLUMNS_GROUPS: {
    ICONS: ['overload', 'comments', 'attachments'],
    GENERAL: ['text', 'project_name', 'project_path', 'wbs', 'resource_id', 'assigned', 'progress', 'status', 'priority', 'predecessors', 'creator', 'jira_key'],
    SCHEDULE: ['start_date', 'end_date', 'duration', 'create_date', 'created_at', 'total_float', 'free_float'],
    WORKLOAD: ['estimation', 'time_tracking'],
    BUDGET: ['total_price', 'actual_cost'],
  },
  CUSTOM_COLUMNS: [
    {
      id: constants.CUSTOM_COLUMNS_TYPES.text.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.text.locale),
      icon: {
        type: 'regular',
        name: 'text-2',
        size: 24,
      },
      tooltip: {
        content: tooltips.text,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.number.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.number.locale),
      icon: {
        type: 'regular',
        name: 'numbers',
        size: 24,
      },
      tooltip: {
        content: tooltips.number,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.date.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.date.locale),
      icon: {
        type: 'regular',
        name: 'calendar',
        size: 24,
      },
      tooltip: {
        content: tooltips.date,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.select.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.select.locale),
      icon: {
        type: 'regular',
        name: 'list',
        size: 24,
      },
      tooltip: {
        content: tooltips.select,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.checkbox.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.checkbox.locale),
      icon: {
        type: 'regular',
        name: 'checkbox-filled',
        size: 24,
      },
      tooltip: {
        content: tooltips.checkbox,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.color.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.color.locale),
      icon: {
        type: 'regular',
        name: 'color-backgroud',
        size: 24,
      },
      tooltip: {
        content: tooltips.color,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.multiselect.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.multiselect.locale),
      icon: {
        type: 'regular',
        name: 'multiselect',
        size: 24,
      },
      tooltip: {
        content: tooltips.multiselect,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.resources.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.resources.locale),
      icon: {
        type: 'regular',
        name: 'team',
        size: 24,
      },
      tooltip: {
        content: tooltips.resources,
        theme: 'columns-bar-view',
        placement: 'left',
      },
    },
    {
      id: constants.CUSTOM_COLUMNS_TYPES.tags.id,
      name: __(constants.CUSTOM_COLUMNS_TYPES.tags.locale),
      icon: {
        type: 'regular',
        name: 'label',
        size: 24,
      },
      tooltip: {
        content: tooltips.tags,
        theme: 'columns-bar-view',
        placement: 'left-end',
      },
    },
  ],
  OPTIONS_AGGREGATIONS_SELECT: [
    {
      id: constants.CUSTOM_COLUMNS_SUBTYPES.sum.id,
      value: __(constants.CUSTOM_COLUMNS_SUBTYPES.sum.locale),
    },
    {
      id: constants.CUSTOM_COLUMNS_SUBTYPES.average.id,
      value: __(constants.CUSTOM_COLUMNS_SUBTYPES.average.locale),
    },
  ],
};

export default columnsConstants;
